export enum UploadImageLinkTypeEnum {  
  ADVERTISER = 'advertiser',
  OUTLET = 'outlet',
  SERVICE = 'service',
  VOUCHERCODE = 'voucher_code',
  COLLECTION = 'collection'
}